module.exports = __webpack_public_path__ + "static/media/sync.2598cefc.svg";